import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=5643e597&scoped=true&lang=pug&"
import script from "./Staffs.vue?vue&type=script&lang=ts&"
export * from "./Staffs.vue?vue&type=script&lang=ts&"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=5643e597&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643e597",
  null
  
)

component.options.__file = "Staffs.vue"
export default component.exports